export default {
  data: [
    {
      KBANK: {
        code: 'KBANK',
        name: 'กสิกรไทย จำกัด (มหาชน)',
        text: 'กสิกรไทย',
        color: { background: '#118F46', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      SCB: {
        code: 'SCB',
        name: 'ไทยพาณิชย์ จำกัด (มหาชน)',
        text: 'ไทยพาณิชย์',
        color: { background: '#4E2A82', copy: 'primary', text: '#FFFFFF' },
      },
    },
    {
      KTB: {
        code: 'KTB',
        name: 'กรุงไทย จำกัด (มหาชน)',
        text: 'กรุงไทย',
        color: { background: '#1EA1DB', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      BAY: {
        code: 'BAY',
        name: 'กรุงศรีอยุธยา จำกัด (มหาชน)',
        text: 'กรุงศรีอยุธยา',
        color: { background: '#6B5C5E', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      GSB: {
        code: 'GSB',
        name: 'ออมสิน',
        text: 'ออมสิน',
        color: { background: '#EB008B', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      UOB: {
        code: 'UOB',
        name: 'ยูโอบี จำกัด (มหาชน)',
        text: 'ยูโอบี',
        color: { background: '#FFFFFF', copy: 'danger', text: '#000000' },
      },
    },
    {
      BBL: {
        code: 'BBL',
        name: 'กรุงเทพ จำกัด (มหาชน)',
        text: 'กรุงเทพ',
        color: { background: '#1F4396', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      TMB: {
        code: 'TMB',
        name: 'ทหารไทย จำกัด (มหาชน)',
        text: 'ทหารไทย',
        color: { background: '#FFFFFF', copy: 'danger', text: '#000000' },
      },
    },
    {
      CITYBANK: {
        code: 'CITYBANK',
        name: 'ซิตี้แบ้งค์',
        text: 'ซิตี้แบ้งค์',
        color: { background: '#FFFFFF', copy: 'danger', text: '#000000' },
      },
    },
    {
      LHBANK: {
        code: 'LHBANK',
        name: 'แลนด์ แอนด์ เฮ้าส์',
        text: 'แลนด์ แอนด์ เฮ้าส์',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      TBANK: {
        code: 'TBANK',
        name: 'ธนชาต จำกัด (มหาชน)',
        text: 'ธนชาต',
        color: { background: '#F37023', copy: 'danger', text: '#000000' },
      },
    },
    {
      BAAC: {
        code: 'BAAC',
        name: 'เพื่อการเกษตรและสหกรณ์การเกษตร',
        text: 'เพื่อการเกษตรและสหกรณ์การเกษตร',
        color: { background: '#29592E', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      GHBANK: {
        code: 'GHBANK',
        name: 'อาคารสงเคราะห์',
        text: 'อาคารสงเคราะห์',
        color: {},
      },
    },
    {
      KKB: {
        code: 'KKB',
        name: 'เกียรตินาคิน จำกัด (มหาชน)',
        text: 'เกียรตินาคิน',
        color: { background: '#009CC9', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      JPMORGAN: {
        code: 'JPMORGAN',
        name: 'เจพีมอร์แกน เชส สาขากรุงเทพฯ',
        text: 'เจพีมอร์แกน เชส',
        color: { background: '', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      CIMB: {
        code: 'CIMB',
        name: 'ซีไอเอ็มบี ไทย จำกัด (มหาชน)',
        text: 'ซีไอเอ็มบี',
        color: { background: '#ED1C24', copy: 'danger', text: '#FFFFFF' },
      },
    },
    {
      DEUTSCHE: {
        code: 'DEUTSCHE',
        name: 'ดอยซ์แบงค์',
        text: 'ดอยซ์แบงค์',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      TISCO: {
        code: 'TISCO',
        name: 'ทิสโก้ จำกัด (มหาชน)',
        text: 'ทิสโก้',
        color: { background: '#FFFFFF', copy: 'danger', text: '#000000' },
      },
    },
    {
      TCRBANK: {
        code: 'TCRBANK',
        name: 'ไทยเครดิต เพื่อรายย่อย',
        text: 'ไทยเครดิต',
        color: {},
      },
    },
    {
      BNP: {
        code: 'BNP',
        name: 'บีเอ็นพี พารีบาส์ สาขากรุงเทพฯ',
        text: 'บีเอ็นพี',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      MIZUHO: {
        code: 'MIZUHO',
        name: 'มิซูโฮ คอร์ปอเรต จำกัด สาขากรุงเทพฯ',
        text: 'มิซูโฮ',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      MEGA: {
        code: 'MEGA',
        name: 'เมกะ สากลพาณิชย์',
        text: 'เมกะ',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      SC: {
        code: 'SC',
        name: 'สแตนดาร์ดชาร์เตอร์ด (ไทย)',
        text: 'สแตนดาร์ดชาร์เตอร์ด',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      BOC: {
        code: 'BOC',
        name: 'แห่งประเทศจีน (ไทย)',
        text: 'แห่งประเทศจีน',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      BOA: {
        code: 'BOA',
        name: 'แห่งอเมริกาฯ',
        text: 'แห่งอเมริกาฯ',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      ASL: {
        code: 'ASL',
        name: 'อิสลามแห่งประเทศไทย',
        text: 'อิสลามแห่งประเทศไทย',
        color: {},
      },
    },
    {
      ICBC: {
        code: 'ICBC',
        name: 'ไอซีบีซี (ไทย)',
        text: 'ไอซีบีซี ',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      EXIM: {
        code: 'EXIM',
        name: 'เพื่อการส่งออกและนำเข้าแห่งประเทศไทย (ธสน.)',
        text: 'การส่งออกและนำเข้าแห่งประเทศไทย (ธสน.) ',
        color: { background: '', copy: 'danger', text: '' },
      },
    },
    {
      TTB: {
        code: 'TTB',
        name: 'ธนาคารทหารไทยธนชาต จำกัด',
        text: 'ทีเอ็มบีธนชาต',
        color: { background: '#fff', copy: 'danger', text: '#000000' },
      },
    },
  ],
}
